import CaptureWarning from "../CaptureWarning";
import React, { useState } from "react";
import { FiPlayCircle } from "react-icons/fi";
import { VscChromeClose } from "react-icons/vsc";
import ReactModal from "react-modal";
import ThreeInOnePlayer from "../../../../components/Slider/ThreeInOnePlayer";
import http, { downloadUrl, URL_S3 } from "../../../../config/BaseUrl";

ReactModal.setAppElement("#root");

const ThreeInOne = (props) => {
  const { event_gif } = props && props;
  const [modalIsOpen, setIsOpen] = useState(false);
  const [threeInOneDetails, setThreeInOneDetails] = useState({});
  const [activeItem, setActiveItem] = useState(null);

  const previewImageDetails = async (id, event_gif, indexItem) => {
    setActiveItem(indexItem);
    await http.get(`media/item-details?media_id=${id}`).then((res) => {
      if (res.data.status === "success") {
        setThreeInOneDetails({ media: res.data.media, event_gif });
      }
    });
    setIsOpen(true);
  };

  const downloadImage = (id, file_name) => {
    window.open(`${downloadUrl}social-gallery-download/${id}`);
  };

  const deleteImage = (id) => {
    if (window.confirm('Are you sure you want to delete this item?')) {
      http.post(`gallery-item-delete/${id}`).then((res) => {
        if (res.data.status === "success") {
          window.location.reload();
        }
      }).catch((err) => {
        console.error('Error deleting item:', err);
        alert('Failed to delete item');
      });
    }
  };

  return (
    <>
      <div className="pt-2 photos">
        <div className="row">
          <div className="col-12">
            <div className="analytic-photos">
              <div className="mt-3 gallery-body">
                <div className="row">
                  <div className="col-12">
                    <h5 className="text-secondary mb-2">3 in 1</h5>
                  </div>
                  <div className="col-12">
                    <div className="photos-list">
                      <div className="row gallery-horizontal">
                        {event_gif && event_gif.length > 0 ? (
                          event_gif.map((item, index) => {
                            return (
                              <div
                                key={item.id}
                                className="mb-4 text-center gallery-item col-md-3"
                                style={{ position: "relative" }}
                              >
                                <div style={{ position: "absolute", top: "5px", right: "5px", zIndex: 10, display: "flex", gap: "5px" }}>
                                  <CaptureWarning media={item} />
                                  <span
                                    className="download-single-button"
                                    onClick={downloadImage.bind(
                                      this,
                                      item.id,
                                      item.event_gif
                                    )}
                                    style={{
                                      position: "relative",
                                      top: "auto",
                                      right: "auto",
                                      background: "rgba(0,0,0,0.75)",
                                      border: "1px solid rgba(255,255,255,0.3)"
                                    }}
                                  >
                                    <i className="lni lni-download"></i>
                                  </span>
                                  <span
                                    className="download-single-button"
                                    onClick={deleteImage.bind(
                                      this,
                                      item.id
                                    )}
                                    style={{
                                      position: "relative",
                                      top: "auto",
                                      right: "auto",
                                      color: "#ff4444",
                                      background: "rgba(0,0,0,0.75)",
                                      border: "1px solid rgba(255,255,255,0.3)"
                                    }}
                                  >
                                    <i className="lni lni-trash"></i>
                                  </span>
                                </div>
                                <div className="image">
                                  <span
                                    className="video"
                                    onClick={previewImageDetails.bind(
                                      this,
                                      item.id,
                                      item.event_gif,
                                      index
                                    )}
                                  >
                                    <img
                                      src={
                                        URL_S3 +
                                        "event_gallery/photo/" +
                                        item.event_photo
                                      }
                                      alt="random-item"
                                      className="img-fluid img-thumbnail"
                                      onClick={previewImageDetails.bind(
                                        this,
                                        item.id,
                                        item.event_gif,
                                        index
                                      )}
                                    />
                                    <span className="video-icon">
                                      <FiPlayCircle />
                                    </span>
                                  </span>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <div className="my-5 text-center col-md-12">
                            <b>Items Not Available</b>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        className="gallery-preview-modal"
        overlayClassName="gallery-preview-overlay"
        contentLabel="3 in 1 preview"
      >
        <div className="fullscreen_view_area">
          <button type="button" className="close_icon" onClick={() => setIsOpen(false)} aria-label="Close 3 in 1 preview">
            <VscChromeClose size="20" />
          </button>
          <div className="closeIconArea">
            <div className="main_area_fullscreen">
                <ThreeInOnePlayer
                  threeInOneShareDetails={threeInOneDetails}
                  dataSlider={event_gif}
                  activeItemIndex={activeItem}
                />
            </div>
          </div>
        </div>
      </ReactModal>
    </>
  );
};

export default ThreeInOne;
